import { usePartnerContext } from "@tm/static/partnerContext";
import { theme } from "@tm/utility/global";
import React from "react";
import { AnchorTagStyle } from "./TextStyles.style";
type Colors = typeof theme;
type ColorKey = keyof Colors;

interface AnchorTagProps {
  fontSize?: string;
  fontWeight?: string;
  color?: Colors[ColorKey];
  children?: React.ReactNode;
  handleClick?: () => void;
  hrefProp?: string;
  textAlign?: "center" | "left" | "right";
  margin?: string;
  handleMouseLeave?: () => void;
  handleMouseEnter?: () => void;
  textTransform?: "uppercase" | "lowercase";
  anchorTitle?: string | undefined;
  targetProp?: string;
  download?: boolean;
  disableState?: boolean;
  width?: string;
  lineHeight?: string;
}

const AnchorTag: React.FC<AnchorTagProps> = ({
  children,
  fontSize = "sm",
  fontWeight = "regular",
  color,
  handleClick,
  hrefProp,
  textAlign,
  margin,
  handleMouseEnter,
  handleMouseLeave,
  textTransform,
  anchorTitle,
  targetProp,
  download = false,
  disableState,
  width,
  lineHeight,
}) => {
  const context = usePartnerContext();
  return (
    <AnchorTagStyle
      context={context ? context : undefined}
      textAlign={textAlign}
      txtfontSize={fontSize}
      txtfontWeight={fontWeight}
      txtcolor={color}
      onClick={handleClick}
      lineHeight={lineHeight}
      href={hrefProp}
      margin={margin}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      textTransform={textTransform}
      title={anchorTitle}
      target={targetProp}
      download={download}
      disableState={disableState}
      width={width}
    >
      {children}
    </AnchorTagStyle>
  );
};

export default AnchorTag;
